import ContactUsApp from 'apps/ContactUs'
import { financingFaqs } from 'vars'
import { getCommonStaticProps } from 'commonPage'
import commonMessages from 'lang/es/common'
import contactMessages from 'lang/es/contact'

export default ContactUsApp

export const getStaticProps = async () => {
  const commonStaticProps = await getCommonStaticProps()
  const messages = {
    ...commonMessages,
    ...contactMessages,
  }

  return {
    props: {
      titleMeta: 'CONTACT_TITLE',
      descriptionMeta: 'CONTACT_DESCRIPTION',
      financingFaqs,
      headerProps: {
        activeIndex: 3,
        whatsappMessage: {
          id: 'CONTACT_WHATSAPP_MESSAGE',
        },
      },
      messages,
      ...commonStaticProps,
    },
  }
}
